import { Button } from 'react-bootstrap'
import styled from 'styled-components'
import breakpoints from '../../../config/Breakpoints'
import useFeedbackStore from '../../feedback/useFeedbackStore'
import { useDarkMode } from '../../../common/hooks/DarkModeContext'
import BooksitoutImages from '../../../images/BooksitoutImages'

const IndexAfterReleaseCard = () => {
	const { open } = useFeedbackStore()
	const { isDark } = useDarkMode()

	return (
		<>
			<Container style={{ backgroundColor: isDark ? '#166534' : '#d1e7de' }} onClick={open}>
				<FeedbackText>책잇아웃에 대한 생각을 들려 주세요</FeedbackText>
				<FeedbackButton>의견 남기기</FeedbackButton>
			</Container>

			<AppsInTossContainer href='https://minion.toss.im/bjWRM1Bv' target='_blank' rel='noreferrer'>
				<TossIcon src={BooksitoutImages.WebsiteLogo.toss} alt='토스 아이콘' />
				<AppsInTossText>토스에서도 책잇아웃을 만나보세요</AppsInTossText>
			</AppsInTossContainer>

			<AppStoreContainer href='https://apps.apple.com/app/booksitout/id6774917952' target='_blank' rel='noreferrer'>
				<AppStoreIcon src={BooksitoutImages.WebsiteLogo.appStore} alt='앱스토어 아이콘' />
				<AppStoreText>앱스토어에서 책잇아웃을 다운로드하세요 (iOS)</AppStoreText>
			</AppStoreContainer>
		</>
	)
}

const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;

	border-radius: 16px;
	padding: 15px;

	@media screen and (max-width: ${breakpoints.sm}) {
		cursor: pointer;
		padding: 20px 15px;
	}
`

const FeedbackText = styled.span`
	font-size: 16px;
	font-weight: 600;
`

const FeedbackButton = styled(Button).attrs({
	variant: 'book',
})`
	padding: 6px 16px;
	font-size: 14px;

	@media screen and (max-width: ${breakpoints.sm}) {
		display: none;
	}
`

const AppsInTossContainer = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;

	margin-top: 15px;
	padding: 15px;

	@media screen and (max-width: ${breakpoints.sm}) {
		padding: 20px 15px;
	}

	border-radius: 16px;
	background-color: #c9e2ff;
	text-decoration: none;
	pointer-events: none;
	cursor: default;

	@media screen and (max-width: ${breakpoints.sm}) {
		pointer-events: auto;
		cursor: pointer;
	}
`

const TossIcon = styled.img`
	width: 30px;
	height: 30px;
	border-radius: 8px;
`

const AppsInTossText = styled.span`
	color: #333d4b;
	font-size: 16px;
	font-weight: 600;
`

const AppStoreContainer = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;

	margin-top: 15px;
	padding: 15px;

	@media screen and (max-width: ${breakpoints.sm}) {
		padding: 20px 15px;
	}

	border-radius: 16px;
	background-color: #f5f5f7;
	text-decoration: none;

	&:hover {
		background-color: #e8e8ed;
	}
`

const AppStoreIcon = styled.img`
	width: 30px;
	height: 30px;
	border-radius: 8px;
`

const AppStoreText = styled.span`
	color: #333d4b;
	font-size: 16px;
	font-weight: 600;
`

export default IndexAfterReleaseCard
